module.exports = __webpack_public_path__ + "static/media/icon-live-ic-event-busy.ed4d0870.svg";